import { render, staticRenderFns } from "./Empresas.vue?vue&type=template&id=6cab0e4e&scoped=true&"
import script from "./Empresas.vue?vue&type=script&lang=js&"
export * from "./Empresas.vue?vue&type=script&lang=js&"
import style0 from "./empresas.scss?vue&type=style&index=0&id=6cab0e4e&lang=scss&scoped=true&"
import style1 from "./empresa_global.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cab0e4e",
  null
  
)

export default component.exports